import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Box from 'shopper/components/Box';
import Button from 'shopper/components/Button';
import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import placeholder from 'lib/placeholder';
import { trackEvent } from 'lib/posthog';

import { CLICK_COUPON_CTA } from 'constants/analytics';

const StoreOffersCtaCard = ({ storeName, storeSlug }) => {
  const handleClick = () => {
    trackEvent(CLICK_COUPON_CTA, {
      option: 'store_offers',
    });
  };

  return (
    <NextLink href={`/promocoes/loja/${storeSlug}/`} passHref>
      <Box
        as="a"
        className="grid min-h-36 grid-cols-[96px_1fr] gap-x-6 gap-y-2 rounded-4 border-2 border-highlight-200 p-4 no-underline dark:border-highlight-200 md:grid-cols-[auto_1fr_1fr_1fr_200px] md:gap-x-8 md:px-8 md:py-6"
        onClick={handleClick}
      >
        <div className="row-span-2 flex h-24 w-24 flex-col items-center justify-center self-center border-r border-dashed border-neutral-high-400 pr-6 dark:border-neutral-low-200 md:pr-8 xl:w-40">
          <Heading
            as="h3"
            className="text-center text-neutral-low-400 dark:text-neutral-high-200 lg:text-[28px]"
            size="size2"
          >
            TOP
          </Heading>
          <Text
            className="text-center text-neutral-low-400 dark:text-neutral-high-200"
            size="size1"
          >
            ITENS
          </Text>
        </div>
        <div className="col-start-2 row-span-2 flex flex-col gap-2 self-center md:contents">
          <Heading
            as="h2"
            className="text-sm font-semibold text-neutral-low-400 dark:text-neutral-high-200 md:col-span-3 md:col-start-2 md:row-span-2 md:self-center lg:text-xl"
            size="size4"
          >
            {placeholder('descriptions.couponStoreOffersCta')} {storeName}
          </Heading>
          <Button
            as="div"
            buttonTextClassName="text-sm md:text-base"
            className="col-start-2 h-8 w-full self-center border-highlight-200 bg-highlight-200 min-size-8 hover:border-highlight-300 hover:bg-highlight-300 md:col-span-1 md:col-start-5 md:row-span-2 md:h-12 md:w-[200px] md:self-center md:justify-self-end md:min-size-10"
            size="size3"
            type="primary"
            full
          >
            {placeholder('actions.couponStoreOffersCta')}
          </Button>
        </div>
      </Box>
    </NextLink>
  );
};

StoreOffersCtaCard.propTypes = {
  storeName: PropTypes.string.isRequired,
  storeSlug: PropTypes.string.isRequired,
};

export default StoreOffersCtaCard;
